/** Default field appearance, separated from sizing for compact and multiline controls. */
export const FORM_CONTROL_APPEARANCE_CLASS_NAME =
  "rounded-xl border-slate-400 bg-white text-base text-slate-900 shadow-xs focus-visible:outline-hidden focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/15 focus-visible:ring-offset-0 disabled:border-slate-200 disabled:bg-slate-50 sm:text-sm";

export const FORM_CONTROL_CLASS_NAME = `${FORM_CONTROL_APPEARANCE_CLASS_NAME} h-12 px-3.5 py-3`;

export const FORM_INPUT_CLASS_NAME = `${FORM_CONTROL_CLASS_NAME} placeholder:text-slate-500 disabled:opacity-100`;

export const FORM_TEXTAREA_CLASS_NAME = `${FORM_CONTROL_APPEARANCE_CLASS_NAME} min-h-32 px-3.5 py-3 placeholder:text-slate-500 disabled:opacity-100`;
